import { createRequest, HttpMethod } from 'ehs-react';
import type { icModel } from 'generated-ts-common';

type NotificationResponse = icModel.saf.infrastructure.model.notification.NotificationResponse;

type NotificationSearchParameters = icModel.saf.infrastructure.model.notification.NotificationSearchParameters;

export interface SearchNotificationsParams {
  searchParams?: Partial<NotificationSearchParameters>;
}

export interface SetNotificationsReadUnreadParams {
  ids: string[];
}

export interface DeleteNotificationParams {
  id: string;
}

export interface MarkAllAsReadParams {
  creationTime: Date;
}

export const searchNotifications = createRequest<
  SearchNotificationsParams,
  NotificationResponse
>({
  operation: 'searchNotifications',
  method: HttpMethod.POST,
  returnsArray: false
});

export const setNotificationsRead = createRequest<
  SetNotificationsReadUnreadParams,
  void
>({
  operation: 'setNotificationsRead',
  method: HttpMethod.POST,
  returnsArray: false
});

export const setNotificationsUnread = createRequest<
  SetNotificationsReadUnreadParams,
  void
>({
  operation: 'setNotificationsUnread',
  method: HttpMethod.POST,
  returnsArray: false
});

export const markAllAsRead = createRequest<MarkAllAsReadParams, void>({
  operation: 'markAllAsRead',
  method: HttpMethod.POST,
  returnsArray: false
});

export const deleteNotification = createRequest<DeleteNotificationParams, void>(
  {
    operation: 'deleteNotification',
    method: HttpMethod.POST,
    returnsArray: false
  }
);
